import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaqSection } from '@/components/ui/FaqSection'; // Adjusted path

const MARKET_BLOOM_FAQS = [
  {
    question: "How does Market Bloom work?",
    answer: "Market Bloom is an online marketplace that connects you with local artisan florists. You can browse flower arrangements, place an order, and have it delivered by the local florist, supporting small businesses in your community."
  },
  {
    question: "How is delivery handled?",
    answer: "Delivery is managed directly by our partner florists. When you enter your delivery address at checkout, you'll see available delivery options, times, and fees from florists who serve your area. Many offer same-day or next-day delivery."
  },
  {
    question: "Can I request a specific florist?",
    answer: "While you can browse products by specific florists on their profile pages, the general search shows available products based on your delivery location. If you have a preferred florist, you can visit their Market Bloom storefront directly to order."
  },
  {
    question: "What if I have an issue with my order?",
    answer: "Your satisfaction is very important to us! If you have any concerns with your order, we first recommend contacting the local florist directly using the details provided in your order confirmation. They are best equipped to quickly address any immediate issues. If you're unable to resolve it with the florist, or for any other inquiries, please don't hesitate to reach out to Market Bloom via our Contact Us page or by calling 1800 FLOWERS. We're here to help ensure a positive experience."
  },
  {
    question: "How do you ensure flower quality and freshness?",
    answer: "We partner with professional local florists who are committed to using high-quality, fresh flowers in their arrangements. Because orders are fulfilled by local businesses, your flowers don't spend long in transit, ensuring they arrive beautiful and fresh."
  },
  {
    question: "Is Market Bloom available Australia-wide?",
    answer: "We are continually expanding our network of partner florists across Australia. Enter your postcode or suburb in the search bar to see florists and products available for delivery in your area."
  },
  {
    question: "How can I become a partner florist?",
    answer: "We're always looking for talented local florists to join Market Bloom! Please visit our 'Become a Florist' page or contact us directly for more information on how to apply and the benefits of partnering with us."
  }
];

export default function FAQsPage() {
  const navigate = useNavigate();

  return (
    <div className="bg-background text-foreground">
      <FaqSection
        title="Frequently Asked Questions"
        description="Find answers to common questions about Market Bloom, ordering, delivery, and supporting local florists."
        items={MARKET_BLOOM_FAQS}
        contactInfo={{
          title: "Still have questions?",
          description: "Our support team is happy to help. Reach out to us directly.",
          buttonText: "Contact Us",
          onContact: () => navigate('/contact'),
        }}
      />
    </div>
  );
} 